var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img_Decypt"},[_c('lazy-component',{staticClass:"laz_com"},[_c('LazyImg',{attrs:{"src":_vm.src,"isDecypt":_vm.isDecypt,"isLoading":_vm.isLoading,"round":_vm.round}}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }